export default [
    {
        component: () => import(/* webpackChunkName: 'painel-senha-parametrizacao' */ '@/views/painel-senha/parametrizacao/Index'),
        path: 'parametrizacao',
        redirect: 'parametrizacao/create',
        children: [
            {
                name: 'painel-senha-parametrizacao-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'painel-senha-parametrizacao' */ '@/views/painel-senha/parametrizacao/Form.vue'),
            },
        ],
    },
]